import React, {Component} from 'react';


export default class extends Component {
    render() {
        return (
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-10 mx-auto">
                            <ul className="list-inline text-center">
                                <li className="list-inline-item">
                                    <a href="https://weibo.com/moshel" target="_blank" rel="noopener noreferrer">
                                        <span className="fa-stack fa-lg">
                                        <i className="fa fa-circle fa-stack-2x"/>
                                        <i className="fa fa-weibo fa-stack-1x fa-inverse"/>
                                        </span>
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://hzy.pw" target="_blank" rel="noopener noreferrer">
                                        <span className="fa-stack fa-lg">
                                        <i className="fa fa-circle fa-stack-2x"/>
                                        <i className="fa fa-home fa-stack-1x fa-inverse"/>
                                        </span>
                                    </a>
                                </li>
                                <li className="list-inline-item">
                                    <a href="https://github.com/h2y" target="_blank" rel="noopener noreferrer">
                                        <span className="fa-stack fa-lg">
                                        <i className="fa fa-circle fa-stack-2x"/>
                                        <i className="fa fa-github fa-stack-1x fa-inverse"/>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <p className="copyright text-muted">
                                Built with <i className="fa fa-heart-o"/> by Moshel in 2018-7
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}



// WEBPACK FOOTER //
// ./src/head-and-foot/Footer.js